import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/left.svg'
import _imports_1 from '@/assets/images/right.svg'
import _imports_2 from '@/assets/images/reload.svg'
import _imports_3 from '@/assets/images/copy.svg'


const _hoisted_1 = { class: "home flex flex-row pl-16 md:pl-[200px]" }
const _hoisted_2 = { class: "text-white flex-col flex p-5 md:p-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-[26px]" }, "Avatars photos", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex-col flex md:flex-row justify-start" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("Use keyword "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-normal" }, "coolperson")
], -1)
const _hoisted_6 = { class: "flex-col md:flex-row flex mt-5 justify-start items-start" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-7 w-7",
  src: _imports_0,
  alt: "Workflow"
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "w-10 h-10 text-cool text-sm text-center flex-row flex justify-center items-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-7 w-7",
  src: _imports_1,
  alt: "Workflow"
}, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-7 w-7",
  src: _imports_2,
  alt: "Workflow"
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "flex flex-row flex-wrap justify-start mt-10 transition-all" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "flex-row flex w-full" }
const _hoisted_19 = ["download", "href"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-5 w-5",
  src: _imports_3,
  alt: "Workflow"
}, null, -1)
const _hoisted_22 = [
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Menu = _resolveComponent("Menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Menu, { type: "avatars" }),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("textarea", {
          id: "random_text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.text) = $event)),
          placeholder: "portrait of coolperson, knights of zodiac man, white and metalic blue color reflected armor, ...",
          class: "placeholder:text-slate-400 text-custom_bg_1 md:w-[400px] py-3 md:h-[120px] px-6 rounded-md mr-2",
          type: "text"
        }, null, 512), [
          [_vModelText, _ctx.text]
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.prompts_list.length) + " prompts in queue", 1),
          (_ctx.paid)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.training())),
                type: "button",
                class: _normalizeClass([{'opacity-60' : _ctx.creating}, "inline-flex items-center tarnsition-all px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"])
              }, " Create task ", 2))
            : _createCommentVNode("", true),
          (!_ctx.paid)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: _ctx.g_link,
                target: "_blank",
                type: "button",
                class: "inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              }, " Create task ", 8, _hoisted_8))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["flex-row flex mt-5", {'opacity-50' : _ctx.loading}])
      }, [
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.paginate(-1))),
          class: "w-10 h-10 mr-2 flex-row flex justify-center items-center font-semibold text-sm bg-cyan-500 text-white rounded-full shadow-sm"
        }, _hoisted_10),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", null, _toDisplayString(_ctx.page_index), 1)
        ]),
        _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.paginate(1))),
          class: "w-10 h-10 ml-2 flex-row flex justify-center items-center font-semibold text-sm bg-cyan-500 text-white rounded-full shadow-sm"
        }, _hoisted_13),
        _createElementVNode("button", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.reload(1))),
          class: "w-10 h-10 ml-20 flex-row flex justify-center items-center font-semibold text-sm bg-teal-500 text-white rounded-full shadow-sm"
        }, _hoisted_15)
      ], 2),
      _createElementVNode("div", _hoisted_16, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.avatars, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "p-2 my_photo_border rounded-2xl mr-2 mb-2"
          }, [
            _createElementVNode("img", {
              class: "w-[200px] rounded-2xl mb-2",
              src: item.url
            }, null, 8, _hoisted_17),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("a", {
                download: item.name,
                target: "_blank",
                href: item.url,
                class: "underline underline-offset-2 text-cool cursor-pointer hover:text-white text-center flex-1"
              }, "Download", 8, _hoisted_19),
              _createElementVNode("div", {
                class: "w-10 cursor-pointer opacity-70 hover:opacity-100",
                onClick: ($event: any) => (_ctx.ping(item))
              }, _hoisted_22, 8, _hoisted_20),
              _createElementVNode("div", null, _toDisplayString(item.sim) + " %", 1)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}